// extracted by mini-css-extract-plugin
export var markdown = "_so-0";
export var tableWrapper = "_so-1";